const BASE_API_URL = process.env.REACT_APP_API_URL + '/profile';

export const fetchUserDetails = async () => {
  const USER_ID = sessionStorage.getItem('userId');
  const TOKEN = sessionStorage.getItem('token');


  const response = await fetch(`${BASE_API_URL}/${USER_ID}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${TOKEN}`,
      'Content-Type': 'application/json',                        
    },
  });

  const result = await response.json();
  return result;
};

export const fetchUserCredits = async () => {
  const USER_ID = sessionStorage.getItem('userId');
  const TOKEN = sessionStorage.getItem('token');


  const response = await fetch(`${BASE_API_URL}/credits/${USER_ID}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${TOKEN}`,
      'Content-Type': 'application/json',                        
    },
  });

  const result = await response.json();
  return result;
};



export const updateUserProfile = async (data) => {
  try {
    const TOKEN = sessionStorage.getItem('token');
    const USER_ID = sessionStorage.getItem('userId');
    
    const response = await fetch(`${BASE_API_URL}/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`,
      },
      body: JSON.stringify({ ...data, user_id: USER_ID }),
    });
    
    const result = await response.json();
    
    if (!response.ok) {
      return {
        isError: true,
        errorMessage: result.message || 'Failed to update profile',
      };
    }
    
    return result;
  } catch (error) {
    return {
      isError: true,
      errorMessage: 'An error occurred while updating the profile',
    };
  }
};

export const saveApiKey = async (data) => {
  try {
    const TOKEN = sessionStorage.getItem('token');
    const USER_ID = sessionStorage.getItem('userId');
    
    const response = await fetch(`${BASE_API_URL}/update_api_key`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`,
      },
      body: JSON.stringify({ api_key:data, user_id: USER_ID }),
    });
    
    const result = await response.json();
    
    if (!response.ok) {
      return {
        isError: true,
        errorMessage: result.message || 'Failed to save API key',
      };
    }
    
    return result;
  } catch (error) {
    return {
      isError: true,
      errorMessage: 'An error occurred while saving the API key',
    };
  }
}

export const fetchApiKey = async () => {
  try {
    const TOKEN = sessionStorage.getItem('token');
    const USER_ID = sessionStorage.getItem('userId');
    
    const response = await fetch(`${BASE_API_URL}/get_api_key/${USER_ID}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`,
      },
    });
    
    const result = await response.json();
    
    if (!response.ok) {
      return {
        isError: true,
        errorMessage: result.message || 'Failed to fetch API key',
      };
    }
    
    return result;
  } catch (error) {
    return {
      isError: true,
      errorMessage: 'An error occurred while fetching the API key',
    };
  }
};

// M-PIN Management API Functions
const MPIN_BASE_API_URL = process.env.REACT_APP_API_URL + '/profile';

export const updateMPIN = async (mpinData) => {
  try {
    const TOKEN = sessionStorage.getItem('token');
    const USER_ID = sessionStorage.getItem('userId');
    
    const response = await fetch(`${MPIN_BASE_API_URL}/update-mpin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`,
      },
      body: JSON.stringify({ 
        userId: Number(USER_ID), 
        mpin: String(mpinData.mpin) // Ensure it's sent as string
      }),
    });
    
    const result = await response.json();
    
    if (!response.ok) {
      return {
        isError: true,
        errorMessage: result.message || 'Failed to update M-PIN',
      };
    }
    
    return result;
  } catch (error) {
    return {
      isError: true,
      errorMessage: 'An error occurred while updating M-PIN',
    };
  }
};

export const getMPINStatus = async () => {
  try {
    const TOKEN = sessionStorage.getItem('token');
    const USER_ID = sessionStorage.getItem('userId');
    
    const response = await fetch(`${MPIN_BASE_API_URL}/mpin-status/${USER_ID}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`,
      },
    });
    
    const result = await response.json();
    
    if (!response.ok || !result.success) {
      return {
        isError: true,
        errorMessage: result.message || 'Failed to fetch M-PIN status',
      };
    }
    
    // Transform the response to match what the component expects
    return {
      isError: false,
      data: {
        isActive: result.data?.isAvailable || false,
        lastUpdated: result.data?.lastUpdated || "--"
      }
    };
  } catch (error) {
    return {
      isError: true,
      errorMessage: 'An error occurred while fetching M-PIN status',
    };
  }
};

export const verifyCurrentMPIN = async (currentMpin) => {
  try {
    const TOKEN = sessionStorage.getItem('token');
    const USER_ID = sessionStorage.getItem('userId');
    
    const response = await fetch(`${MPIN_BASE_API_URL}/verify-mpin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`,
      },
      body: JSON.stringify({ 
        userId: Number(USER_ID), 
        mpin: currentMpin 
      }),
    });
    
    const result = await response.json();
    
    if (!response.ok) {
      return {
        isError: true,
        errorMessage: result.message || 'Invalid current M-PIN',
      };
    }
    
    return result;
  } catch (error) {
    return {
      isError: true,
      errorMessage: 'An error occurred while verifying M-PIN',
    };
  }
};

export const deactivateMPIN = async () => {
  try {
    const TOKEN = sessionStorage.getItem('token');
    const USER_ID = sessionStorage.getItem('userId');
    
    const response = await fetch(`${MPIN_BASE_API_URL}/deactivate-mpin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`,
      },
      body: JSON.stringify({ 
        userId: Number(USER_ID)
      }),
    });
    
    const result = await response.json();
    
    if (!response.ok) {
      return {
        isError: true,
        errorMessage: result.message || 'Failed to deactivate M-PIN',
      };
    }
    
    return result;
  } catch (error) {
    return {
      isError: true,
      errorMessage: 'An error occurred while deactivating M-PIN',
    };
  }
};

